import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivateInternalRole } from './common/helpers/internal.guard';
import { canActivateExternalRole } from './common/helpers/external.guard';
import { Roles } from './common/helpers/roles';
import { canActivatePartnersRole } from './common/helpers/auth-parters.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/internal-home/internal-home.module').then(m => m.InternalHomeModule),
    // pathMatch: 'full',
    canMatch: [canActivateInternalRole],
  },
  {
    path: 'partners',
    loadComponent: () => import('./pages/partners/external-home/external-home.component').then(m => m.ExternalHomeComponent),
    canMatch: [canActivateExternalRole],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'tracker',
      },
      {
        path: 'tracker',
        loadComponent: () => import('./pages/partners/tracker/tracker.component').then(m => m.TrackerComponent),
        canActivate: [canActivatePartnersRole],
        data: { roles: Roles.PARTNERS_VIEW_CPM_BASE },
        title: 'Tracker'
      },
      {
        path: '**',
        redirectTo: '/forbidden'
      },
    ]
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./pages/fallback/fallback.component').then(m => m.FallbackComponent),
  },
  {
    path: '**',
    redirectTo: '/forbidden'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
